/* eslint-disable no-underscore-dangle */
const {
  getContentValue,
  appendPath
} = require('@truqc/content-path');
const {
  isPlainObject
} = require('lodash');
const {
  evaluateSource
} = require('../lib/evaluateSource');

/**
  * @function evalute - evaluate arrayFilterBehavior
  */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  const logContentPath = await evaluateSource(source.logContentPath, content, parentContentPath, transientContext, nativeFunctions);
  if (logContentPath === undefined) {
    return undefined;
  }
  // resolve absolute path
  const fullPath = appendPath(parentContentPath, logContentPath);
  const auditTrailLog = getContentValue(fullPath, content);
  if (!isPlainObject(auditTrailLog)) {
    return undefined;
  }
  const sortedKeys = Object.keys(auditTrailLog).sort((a, b) => new Date(auditTrailLog[b]._created) - new Date(auditTrailLog[a]._created));
  let done = false;
  for (let i = 0; i < sortedKeys.length && !done; i += 1) {
    const key = sortedKeys[i];
    const log = auditTrailLog[key];
    const {
      contentPath,
      breadcrumbs,
      user,
      displayValue,
      comment,
      previousCreatedDate
    } = log;
    if (previousCreatedDate !== undefined) {
      // we are done - we have already processed the rest of these.
      done = true;
    } else if (i + 1 < sortedKeys.length) {
      // find the most recent log prior to this log        previousCreatedDate = null;
      let found = false;
      for (let j = i + 1; j < sortedKeys.length && !found; j += 1) {
        const findKey = sortedKeys[j];
        const testLog = auditTrailLog[findKey];
        if (testLog.contentPath === contentPath && testLog.breadcrumbs === breadcrumbs) {
          found = true;
          // found it!
          log.previousCreatedDate = testLog._created;
          log.previousValue = testLog.value;
          log.previousDisplayValue = testLog.displayValue;
        }
      }
    }
    let logString = `${user} edited ${breadcrumbs}`;
    if (log.displayValue || log.previousDisplayValue) {
      // create the audit trail string.
      if (log.previousDisplayValue === undefined) {
        // not found, so treat as null
        logString += ' from null';
      } else {
        logString += ` from ${log.previousDisplayValue}`;
      }
      if (displayValue === undefined) {
        // not found, so treat as null
        logString += ' to null';
      } else {
        logString += ` to ${displayValue}`;
      }
    }
    if (comment !== undefined) {
      logString += ` with note ${comment}`;
    }
    log.logString = logString;
  }
  return auditTrailLog;
};
module.exports = {
  evaluate
};